import React from "react";
import { LineChart } from "@mui/x-charts";

const PlayboxPricingMain = ({ podInfo }) => {
    const xData = [
        new Date(2025, 6, 1),
        new Date(2025, 6, 2),
        new Date(2025, 6, 3),
        new Date(2025, 6, 4),
        new Date(2025, 6, 5),
        new Date(2025, 6, 6),
        new Date(2025, 6, 7),
    ];

    const yData = [15, 18, 20, 22, 21, 25, 28];

    return (
        <div className="playbox_logs_main">
            <p className="playbox_logs_main_title">Playbox usage</p>
            <p className="playbox_logs_main_subtitle">Usage and pricing forecast</p>

            <div className="actual_pricing_container">
                <div className="actual_pricing_cont">
                    <p className="actual_pricing_cont_title">Current charges</p>
                                        <p className="actual_pricing_cont_subtitle">Represents present charges</p>
                    <p className="actual_pricing_cont_charge">$20.85</p>
                </div>
                <div className="actual_pricing_cont">
                    <p className="actual_pricing_cont_title">Forecast charges</p>
                                        <p className="actual_pricing_cont_subtitle">Represents forecast of usage</p>
                    <p className="actual_pricing_cont_charge">$20.85</p>
                </div>
            </div>

            {/* <div className="pricing_playbox_graph" style={{ height: 300, width: "100%" }}>
                <LineChart
                    xAxis={[
                        {
                            scaleType: "time",
                            data: xData, // Important: pass X axis data array here
                        },
                    ]}
                    yAxis={[{ scaleType: "linear" }]}
                    series={[
                        {
                            data: yData,
                            label: "Pricing",
                            color: "#269ae2",  // <-- set color here
                            lineProps: { strokeWidth: 2 },  // keep strokeWidth here
                        },
                    ]}

                />
            </div> */}
        </div>
    );
};

export default PlayboxPricingMain;
